import { z } from 'zod'

/**
 * What a venue sells (docs/sales.spec.md, "The price list"): a package priced by
 * season and day of the week, a price per guest, or an add-on. Mirrors the
 * `SalesItemKind` enum in the Prisma schema — the two must stay in sync.
 */
export const SALES_ITEM_KINDS = ['package', 'per_guest', 'add_on'] as const

export const salesItemKindSchema = z.enum(SALES_ITEM_KINDS)

export type SalesItemKind = z.infer<typeof salesItemKindSchema>

export const SALES_ITEM_KIND_LABELS: Readonly<Record<SalesItemKind, string>> = {
  package: 'Package',
  per_guest: 'Per guest',
  add_on: 'Add-on',
}
